<template>
  <div class="wrapper input-wrapper position-relative noselect">
    <transition-group name="zoom" class="wrapper member-list-span-wrapper">
      <div
        class="selected-option"
        v-for="member in selected"
        :key="member.id + '' + member.type"
        @click="removeFromSelected(member)"
      >
        <span>{{ member.name | clean }}</span>
        <span class="option-remove icon-close"></span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters("group", {
      selected: "getSelected"
    })
  },
  methods: {
    ...mapMutations("group", {
      removeFromSelected: "removeFromSelected"
    })
  },
  filters: {
    clean(value) {
      value = value.replace(/&amp;/g, "&").replace(/&amp;/g, "&");
      return value;
    }
  }
};
</script>

<style scoped>
.wrapper {
  position: relative;
  padding-top: 7px;
  border-bottom: none;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 10px;
}

.input-wrapper:active {
  background-color: transparent !important;
}

.selected-option {
  border: 1px solid #ddcea8;
  background-color: #fefdfa;
  padding: 4px 10px;
  margin-right: 10px;
  border-radius: 4px;
  margin-bottom: 10px;
  font-size: 14px;
}

.selected-option:hover {
  cursor: pointer;
  background-color: #f7f7f7;
}

.option-remove {
  position: relative;
  margin-left: 5px;
  font-weight: bolder;
  bottom: 1px;
}

.zoom-enter-active {
  animation: zoomIn 0.2s ease-in-out forwards;
}

.zoom-leave-active {
  animation: zoomOut 0.2s ease-in-out forwards;
}
.member-list-span-wrapper {
  /*--max-height: calc(100vh - 324px);--*/
  max-height: 100px;
  overflow-y: auto;
}
.icon-close {
  height: 12px;
  width: 12px;
}
@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

@keyframes zoomOut {
  from {
    opacity: 1;
  }

  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
}
</style>
